/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ECustomSearchType {
    Equals = 'Equals',
    NotEquals = 'NotEquals'
}


export function ECustomSearchTypeFromJSON(json: any): ECustomSearchType {
    return ECustomSearchTypeFromJSONTyped(json, false);
}

export function ECustomSearchTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ECustomSearchType {
    return json as ECustomSearchType;
}

export function ECustomSearchTypeToJSON(value?: ECustomSearchType | null): any {
    return value as any;
}

